export default __webpack_public_path__ + "static/Restaurant2-928675c3ee6e320fbd47fab9c3037e16.jpg";